<template>
	<div class="page-container">
		<div class="back_left" @click="$router.go(-1)" />
		<div class="form-wrapper">
			<form class="card-form">
				<div class="form-title">收货地址</div>

				<div class="form-group">
					<label>收件人姓名:</label>
					<input v-model="formData.name" type="text" required placeholder="请输入收件人姓名" :disabled="hasAddress">
				</div>

				<div class="form-group">
					<label>联系电话:</label>
					<input v-model="formData.phone" type="text" required placeholder="请输入联系电话" :disabled="hasAddress">
				</div>

				<div class="form-group">
					<label>所在地区:</label>
					<input v-model="formData.areaText" type="text" readonly required placeholder="请选择所在地区"
						@click="!hasAddress && (showAreaPopup = true)" :class="{ 'disabled-input': hasAddress }">
				</div>

				<div class="form-group">
					<label>详细地址:</label>
					<textarea v-model="formData.detailAddress" required placeholder="请输入详细地址"
						@input="autoResizeTextarea" ref="detailAddressTextarea" rows="1" :disabled="hasAddress">
					</textarea>
				</div>

				<!-- <div class="form-group">
					<label>备注:</label>
					<textarea v-model="formData.remark" placeholder="选填" @input="autoResizeTextarea"
						ref="remarkTextarea" rows="1"></textarea>
				</div> -->
			</form>
		</div>

		<van-popup v-model="showAreaPopup" position="bottom" round :style="{ height: '40%' }">
			<van-area :area-list="areaList" :value="formData.areaCode" @confirm="onAreaConfirm"
				@cancel="showAreaPopup = false" title="请选择所在地区" />
		</van-popup>

		<button class="confirm-btn" @click="handleSubmit" v-if="!hasAddress">立即提交</button>
		<button class="confirm-btn" style="background: #ccc; color: #666;" v-else>已有地址，不可修改</button>
		<div class="confirm-text">
			<span>请认真核对信息,提交后不可更改</span>
			<span style="margin-top: 10px;">需更改请联系在线客服</span>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import {
		Popup,
		Area
	} from 'vant';
	import {
		areaList
	} from '@vant/area-data';

	export default {
		components: {
			[Popup.name]: Popup,
			[Area.name]: Area
		},
		data() {
			return {
				formData: {
					phone: '',
					name: '',
					areaCode: '', // 地区编码
					areaText: '', // 地区显示文本
					detailAddress: '', // 详细地址
					// remark: '' // 备注
				},
				showAreaPopup: false,
				areaList: areaList,
				hasAddress: false,
			}
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			// 看个人信息
			this.getAddress();
			// 检查是否是从exchange页面跳转过来的
			if (this.$route.query.from === 'exchange') {
				console.log('从exchange页面跳转过来');
			}
		},
		methods: {
			getAddress() {
				Fetch('/user/address_get').then((r) => {
					if (r.code === 1 && r.data) {
						// 有地址数据
						this.hasAddress = true;
						// 将后端返回的地址数据赋值给formData
						this.formData = {
							...this.formData,
							...r.data
						};
						// 如果后端返回的地址是一个完整字符串，需要拆分处理
						if (r.data.address) {
							this.splitAddress(r.data.address);
						}
					} else {
						// 没有地址或获取失败
						this.hasAddress = false;
					}
				}).catch(() => {
					this.hasAddress = false;
				});
			},
			// 拆分地址字符串为地区地址和详细地址
			splitAddress(fullAddress) {
				if (!fullAddress) return;

				// 按空格分割地址字符串
				const parts = fullAddress.split(' ');

				if (parts.length >= 3) {
					// 前三个部分作为省、市、区
					const province = parts[0] || '';
					const city = parts[1] || '';
					const district = parts[2] || '';

					// 拼接省市区作为地区地址
					this.formData.areaText = [province, city, district].filter(Boolean).join(' ');

					// 剩余部分作为详细地址
					this.formData.detailAddress = parts.slice(3).join(' ');

					// 设置地区编码（这里需要根据省市区名称获取对应的编码，可能需要额外的逻辑）
					// this.formData.areaCode = this.getAreaCode(province, city, district);
				} else if (parts.length === 2) {
					// 只有两个部分的情况（如直辖市）
					const province = parts[0] || '';
					const city = parts[1] || '';

					this.formData.areaText = [province, city].filter(Boolean).join(' ');
					this.formData.detailAddress = '';
				} else {
					// 只有一个部分或格式不正确
					this.formData.areaText = fullAddress;
					this.formData.detailAddress = '';
				}

				console.log('拆分结果:', {
					fullAddress,
					areaText: this.formData.areaText,
					detailAddress: this.formData.detailAddress
				});
			},
			// 地区选择确认
			onAreaConfirm(selectedValues) {
				// selectedValues 是选中的地区对象数组
				if (selectedValues && selectedValues.length > 0) {
					// 拼接地区文本
					const areaText = selectedValues.map(area => area.name).join(' ');
					// 获取地区编码（通常是最后一个选中的地区的编码）
					const areaCode = selectedValues[selectedValues.length - 1].code;

					this.formData.areaText = areaText;
					// this.formData.areaCode = areaCode;
				}
				this.showAreaPopup = false;
			},
			// 自动调整textarea高度
			autoResizeTextarea(event) {
				const textarea = event.target;
				textarea.style.height = 'auto';
				textarea.style.height = textarea.scrollHeight + 'px';
			},
			handleSubmit() {
				if (this.hasAddress) {
					this.$toast({
						className: "toastName",
						message: '您已添加收货地址\n如需修改请联系在线客服',
					});
					return false;
				}
				if (!this.formData.name) {
					this.$toast({
						className: "toastName",
						message: '请输入收件人姓名',
					});
					return false;
				}
				if (!this.formData.phone) {
					this.$toast({
						className: "toastName",
						message: '请输入联系电话',
					});
					return false;
				}
				if (!this.formData.areaText) {
					this.$toast({
						className: "toastName",
						message: '请选择所在地区',
					});
					return false;
				}
				if (!this.formData.detailAddress) {
					this.$toast({
						className: "toastName",
						message: '请输入详细地址',
					});
					return false;
				}
				// 构建完整的地址信息
				const fullAddress = {
					name: this.formData.name,
					phone: this.formData.phone,
					address: this.formData.areaText + ' ' + this.formData.detailAddress, // 合并地区地址和详细地址
					// areaCode: this.formData.areaCode,
					// remark: this.formData.remark
				};
				Fetch('/user/address_add', fullAddress).then(res => {
					console.log(res);
					this.$toast({
						className: "toastName",
						message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
					});

					// 提交成功后可以跳转回上一页或其他操作
					if (res.code === 1) {
						this.hasAddress = true;

						// 检查是否是从exchange页面跳转过来的
						if (this.$route.query.from === 'exchange') {
							// 跳转回exchange页面，并传递参数表示是从address页面回来的
							setTimeout(() => {
								this.$router.push({
									path: '/exchange',
									query: {
										from: 'address'
									}
								});
							}, 1500);
						} else {
							// 原有逻辑，返回上一页
							setTimeout(() => {
								this.$router.go(-1);
							}, 1500);
						}
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.page-container {
		height: 100vh;
		background: url(~@/assets/my_bg.png) 100% no-repeat;
		background-size: 10rem 100%;
		position: relative;
	}

	.headers {
		color: #ffd08e;
		font-size: 24px;
		position: absolute;
		top: 10%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 100%;
		text-align: center;
	}

	.form-wrapper {
		position: absolute;
		top: 40%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 90%;
		max-width: 500px;
		background: #fff;
		padding: 0 30px 30px;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.card-form h2 {
		text-align: center;
		margin-bottom: 20px;
	}

	.form-title {
		width: 200px;
		margin: 0 auto 10px;
		background: #d7000f;
		color: #fff;
		border-radius: 0 0 12px 12px;
		padding: 8px 0;
		font-size: 5.33333vw;
		text-align: center;
		margin-bottom: 18px;
		font-weight: bold;
	}

	.form-group {
		margin-bottom: 20px;
		font-size: 3.73333vw;
	}

	label {
		display: block;
		margin-bottom: 8px;
	}

	input,
	textarea {
		width: 100%;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
		box-sizing: border-box;
		font-family: inherit;
		font-size: inherit;
		resize: none;
		/* 禁止手动调整大小 */
		overflow: hidden;
		/* 隐藏滚动条 */
		min-height: 40px;
		/* 最小高度 */

		&:read-only {
			background-color: #f8f8f8;
			cursor: pointer;
		}
	}

	.disabled-input {
		background-color: #f8f8f8 !important;
		color: #666;
		cursor: not-allowed !important;
	}

	.preview img {
		max-width: 100%;
		max-height: 200px;
		margin-top: 10px;
	}

	.confirm-btn {
		position: absolute;
		bottom: 170px;
		width: 80%;
		max-width: 500px;
		left: 50%;
		transform: translateX(-50%);
		padding: 12px 40px;
		background: #ffdf9a;
		color: red;
		border: none;
		border-radius: 4px;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
	}

	.confirm-text {
		font-weight: bold;
		position: absolute;
		bottom: 120px;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;
		display: flex;
		flex-direction: column;
		width: 80%;
		font-size: 15px;
		color: #fff;
	}

	.add-card {
		display: block;
		width: 100%;
		height: 150px;
		line-height: 150px;
		background: #fff0e0;
		color: #d7000f;
		border: 1px dashed #d7000f;
		border-radius: 6px;
		font-size: 15px;
		text-align: center;
		margin-bottom: 12px;
		cursor: pointer;
	}

	.tip {
		color: #d7000f;
		font-size: 12px;
		text-align: center;
		margin-top: 8px;
		margin-bottom: 10px;
	}

	.imggw {
		position: absolute;
		top: 18%;
		left: 50%;
		transform: translateX(-50%);
	}
</style>